import React, { useState, useEffect, Suspense } from "react";
import { Route, Routes } from 'react-router-dom';
import logo from './logo.svg';
import './App.css';
import AuthService from "./services/auth.service";
import DetectorsByParking from './detectors/DetectorsByParking';
import ParkingList from './parkings/ParkingList';
import MainNavigation from './components/layout/MainNavigation';
import Home from './components/layout/Home';
import Help from './components/layout/Help';
import ParkingDetails from './parkings/ParkingDetails';
import DetectorsByParkingTable from './detectors/DetectorsByParkingTable';
import ParkingStats from './parkings/ParkingStats';
import ParkingErrors from "./parkings/ParkingErrors";
import LedTables from "./services/ledTables";
import LedTableNew from "./services/ledTableNew";
import HistoryChart from './components/charts/HistoryChart';
import Register from "./components/Register";
import ParkingNew from "./parkings/ParkingNew";
import "bootstrap/dist/css/bootstrap.min.css";

import LocaleContext from "./LocaleContext";

import { Container } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import Loading from './components/Loading';

import i18n from './i18n';

function App() {
  const [showModeratorBoard, setShowModeratorBoard] = useState(false);
  const [showAdminBoard, setShowAdminBoard] = useState(false);
  const [currentUser, setCurrentUser] = useState(undefined);

  const [locale, setLocale] = useState(i18n.language);

  i18n.on('languageChanged', (lng) => setLocale(i18n.language));

  useEffect(() => {
    const user = AuthService.getCurrentUser();
    if (user) {
      setCurrentUser(user);
      setShowModeratorBoard(user.roles.includes("ROLE_MODERATOR"));
      setShowAdminBoard(user.roles.includes("ROLE_ADMIN"));
    }

  }, []);
  const logOut = () => {
    AuthService.logout();
  };

  return (
    <LocaleContext.Provider value={{ locale, setLocale }}>
    <Suspense fallback={<Loading />}>
    <div>
    <MainNavigation/>
    <Routes>
    <Route path='/' element={<Home/>}/>
    <Route path='/parkingDetails/:parkingID' element={<ParkingDetails/>}/>
    <Route path='/detectorsTable/:parkingID' element={<DetectorsByParkingTable/>}/>
    <Route path='/parkingStats/:parkingID' element={<ParkingStats/>}/>
    <Route path='/parkings' element={<ParkingList/>}/>
    <Route path='/Help' element={<Help/>}/>
    <Route path="/register" element={<Register/>} />
    <Route path='/detectorDetails/:parkingID/:address' element={<HistoryChart/>}/>
    <Route path='/ledTables' element={<LedTables />} />
    <Route path='/parkingErrors' element={<ParkingErrors />} />
    <Route path='/parkingNew' element={<ParkingNew />} />
    <Route path='/ledTableNew' element={<LedTableNew />} />
    </Routes>
    </div>
    </Suspense>
    </LocaleContext.Provider>
  );
}

export default App;
